<div class="content-wrapper">
  @if (phoneNumbers()) {
    <mat-card class="content">
      <div class="content-header">
        <h2>
          Alle telefoonnummers <span>({{ totalPhoneNumbers() }})</span>
        </h2>
        <mat-form-field class="mat-form-field-no-subscript">
          <mat-label>Zoeken</mat-label>
          <input matInput autocomplete="off" placeholder="Zoeken" [formControl]="searchCtrl" />
          <button
            mat-icon-button
            matSuffix
            aria-label="Zoekopdracht wissen"
            (click)="clearSearch(); $event.stopPropagation()"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <mat-table mat-table #table [dataSource]="filteredPhoneNumbers()">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Naam</mat-header-cell>
          <mat-cell *matCellDef="let phoneNumber">
            @if (phoneNumber.name) {
              <p class="text-truncate">
                {{ phoneNumber.name }}
              </p>
            }
          </mat-cell>
        </ng-container>
        <!-- Order Column -->
        <ng-container matColumnDef="order">
          <mat-header-cell class="hide-column" *matHeaderCellDef>Volgordenummer</mat-header-cell>
          <mat-cell class="hide-column" *matCellDef="let phoneNumber">
            @if (phoneNumber.order !== undefined && phoneNumber.order !== null) {
              <p class="text-truncate">
                {{ phoneNumber.order }}
              </p>
            }
          </mat-cell>
        </ng-container>
        <!-- Phone Column -->
        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef>Telefoonnummer</mat-header-cell>
          <mat-cell *matCellDef="let phoneNumber">
            @if (phoneNumber.phone) {
              <p class="email text-truncate">
                {{ phoneNumber.phone }}
              </p>
            }
          </mat-cell>
        </ng-container>
        <!-- Button Column -->
        <ng-container matColumnDef="button">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let phoneNumber">
            <div class="buttons">
              <button mat-icon-button aria-label="Telefoonnummer bewerken">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                aria-label="Telefoonnummer verwijderen"
                (click)="deleteItem(phoneNumber); $event.stopPropagation()"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let phoneNumber; columns: displayedColumns"
          class="user"
          role="button"
          tabindex="0"
          aria-label="Telefoonnummer openen"
          (click)="editItem(phoneNumber)"
          (keydown.enter)="editItem(phoneNumber)"
          (keydown.space)="$event.preventDefault(); editItem(phoneNumber)"
          matRipple
        ></tr>
      </mat-table>
    </mat-card>
  } @else {
    <div class="content-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
